import React, { useState } from 'react'
import './contact.scss'
import { Container, Row, Form, Button } from 'react-bootstrap'
import emailjs from 'emailjs-com';
import Message from '../../../Message'

function Contact() {
const [message, setMessage] = useState('')
const [result, setResult] = useState('')
function sendEmail(e) {
   e.preventDefault();
   
 emailjs.sendForm('service_z05pttp', 'template_rep5ckp', e.target, 'user_4Hy4MayeEUlfPu46wvSqo')
    .then((result) => {
       console.log(result.text)
       setResult('success')
       setMessage('Message Sent Successfully!')
       setTimeout(() => {
        setResult('')
      }, 4000)
    }, (error) => {
      console.log(error.text);
       setResult('fail')
       setMessage('An Error Occurred While Sending The Message, Try Again!')
       setTimeout(() => {
        setResult('')
      }, 4000)
   });
    e.target.reset()
}

    return (
        <section id='contact' className='contact section'>
               <h1>Get<span>In Touch</span></h1>
            <Container className='contact-container'>
               <div className='contact-container-form'>
                  <h3 className='contact-container-title'>Contact</h3>
                    {result === 'success' && <Message text={message} color='#13883e'/>}
                    {result === 'fail' && <Message text={message} color='#b73326'/>}
                    <Form className='contact-container-formControl' onSubmit={sendEmail}>
                       <Row>
                         <Form.Group className='col-12'>
                          <Form.Control className='contact-container-formControl-input' type='text' name='name' placeholder='your name' required/>
                         </Form.Group>
                         <Form.Group className='col-12'>
                          <Form.Control className='contact-container-formControl-input' type='email' name='email' placeholder='your email' required/>
                        </Form.Group>
                        <Form.Group className='col-12'>
                          <Form.Control className='contact-container-formControl-input' type='text' name='subject' placeholder='subject' required/>
                        </Form.Group>
                        <Form.Group className='col-12'>
                          <Form.Control className='contact-container-formControl-input' as="textarea" rows={3}  name='message' placeholder='message' required/>
                        </Form.Group>
                        <Form.Group className='col-12'>
                          <Button className='contact-container-formControl-btn' type='submit'>Send Message</Button>
                         </Form.Group>
                     </Row>
                   </Form>
               </div>
               <div className='contact-container-details'>
                  <h3 className='contact-container-title'>Contact Details</h3>
                  <ul className='contact-container-details-list'>
                     <li className='contact-container-details-list-item'>
                       <span>Email</span>
                         shmagigavashelashvili@yahoo.com
                     </li>
                     <li className='contact-container-details-list-item'>
                       <span>Phone</span>
                         +995 599 710 715
                     </li>
                  </ul>
               </div>
            </Container>
      </section>
    )
}

export default Contact
